module.exports = __webpack_public_path__ + "media/customizations/cherrycreektrail/logo-new-a6590e5c401b0fa8c6dc65ea0f3c1e31.png";